import { render } from "./AngleUpDownIcon.vue?vue&type=template&id=412f5e4c&scoped=true&ts=true"
import script from "./AngleUpDownIcon.vue?vue&type=script&lang=ts"
export * from "./AngleUpDownIcon.vue?vue&type=script&lang=ts"

import "./AngleUpDownIcon.vue?vue&type=style&index=0&id=412f5e4c&lang=scss&scoped=true"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412f5e4c"]])

export default __exports__